<template>
    <v-container>
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading"/>
        <template v-if="!loading">
            <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            <br/>
                <election-proportionality-over-time :selectedMpOrSenator="selectedMpOrSenator"></election-proportionality-over-time>
            <br/>        

            <v-flex xs2>
                <v-autocomplete
                    label="Election"
                    v-model="electionSelected"
                    :items="elections"></v-autocomplete>
            </v-flex>
            <br/>

            <chart :chartData="chartData"/>
            <br/>
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import ElectionProportionalityOverTime from './ElectionProportionalityOverTime.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseElectionsDropdown();
    },
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        ElectionProportionalityOverTime,
        Chart
    },
    data() {
        return {
            title: 'Difference between votes received and seats won',
            loading: true,
            items: [],
            elections: [],
            electionSelected: null,
            selectedMpOrSenator: ['senator', 'mp'],
        }
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/ElectionProportionality?electionId=${this.electionSelected}&mpOrSenator=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        initialiseElectionsDropdown() {
            const url = `Elections/Elections`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.elections = response
                        .data
                        .filter(e => !e.Division)
                        .map(e => ({ text: e.Year, value: e.Id }));
                    this.electionSelected = this.elections[0].value;
                    this.initialiseItems();
                });
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        },
        electionSelected: function() {
            this.initialiseItems();
        }
    },
    computed: {
        chartData() {
            const series = [
                {
                    name: 'Percentage Votes',
                    data: this.items.map(i => i.PercentageVotes),
                    color: '#686de0'
                },
                {
                    name: 'Percentage Seats',
                    data: this.items.map(i => i.SeatsPercentage),
                    color: '#f0932b'
                }
            ]
            return {
                chart: {
                    type: 'bar',
                    height: 1000
                },
                title: {
                    text: 'Difference between seats won (%) and votes received (%)'
                },
                xAxis: {
                    categories: this.items.map(i => i.Party),
                    title: {
                        text: null
                    }
                },
                tooltip: {
                    valueDecimals: 2,
                    valueSuffix: '%'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Percentage',
                        align: 'high'
                    },
                    labels: {
                        overflow: 'justify'
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:,.2f}'
                        }
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'top',
                    x: -30,
                    floating: true,
                    borderWidth: 1,
                    shadow: true
                },
                series
            }
        }
    }
}
</script>